<template>
  <div class="select-body">
    <div class="textShow" v-if="!isAll">
      <span>已选择</span>
      <span class="num">{{ num }}</span>
      <span>个</span>
    </div>
    <div v-else>
      <div class="textShow" v-if="!num">
        <span>默认全部</span>
      </div>
      <div class="textShow" v-else>
        <span>已选择</span>
        <span class="num">{{ num }}</span>
        <span>个</span>
      </div>
    </div>
    <span @click="btnClick">{{ btnText }}</span>
  </div>
</template>
<script>
export default {
  props: {
    // 已选择数量
    num: {
      typee: Number,
      default: 0,
    },
    // 按钮文字
    btnText: {
      type: String,
      default: "选择商品",
    },
    // 是否默认全部
    isAll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.$emit("bin");
    },
  },
};
</script>
<style lang="scss" scoped>
.select-body {
  background: #ffffff;
  border-radius:4px;
  border: 1px solid #ececec;
  // width: %;
  min-width: 290px;
  padding: 4px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-family: PingFang SC, PingFang SC;
  height: 30px;
  > span {
    font-weight: 400;
    font-size: $main-size;
    color: #3159ff;
    cursor: pointer;
    height: 22px;
    line-height: 22px;
  }
  &:hover {
   border-color: $theme-color !important
  }
}
.textShow {
  min-width: 60px;
  padding: 0 5px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  background: #f5f5f5;
  border-radius: 2px 2px 2px 2px;
  font-weight: 400;
  font-size: $main-size;
  color: #333333;
  margin-right: 8px;
  .num {
    color: rgba(244, 129, 31, 1);
  }
}
</style>
